import { useEffect, useState } from 'react'

export const useModalVisibility = (show) => {
    const [isVisible, setIsVisible] = useState(false)

    useEffect(() => {
        if (show) {
            setIsVisible(true)
        } else {
            setTimeout(() => setIsVisible(false), 300)
        }
    }, [show])

    return isVisible
}
